export const contentTranslation = {
    title: {
        en: { text: "404 Page Not Found" },
        he: { text: "404 העמוד לא נמצא" },
        ar: { text: "404 الصفحة غير موجودة" },
    },
    subTitle: {
        en: {
            text: "Looks like you're lost!<br />The page you're looking for isn't found :(",
        },
        he: { text: "הדף שאתה מחפש לא נמצא :(" },
        ar: { text: "الصفحة التي تبحث عنها غير متوفرة :(" },
    },
    backToHomeBtn: {
        en: { text: "Back to Home" },
        he: { text: "חזרה לדף ראשי" },
        ar: { text: "العودة للرئيسية" },
    },
};
